/**
 * Internal dependencies
 */
import './get-raw-reports';
import { applyEdits } from 'state/utils';
import isEditedReportDirty from './is-edited-report-dirty';
import getReport from './get-report';
import getEdits from './get-edits';

export default (state, id) => {
	if (isEditedReportDirty(state, id)) {
		let report = getReport(state, id);
		let edits = getEdits(state, id);
		report = applyEdits(report, edits);
		return report;
	}

	return getReport(state, id);
};
